import React, { useContext } from 'react'
import { AuthContext } from '../../Contexts/AuthContext';
import { CreateTrainer } from '../TrainerDetails/CreateTrainer';
import { CreateGymProfile } from '../GymFacilities/CreateGymProfile';
import CreateTrainingProvider from '../TrainingProvides/CreateTrainingProvider';

// export function MyProfile() {
//     return (
//         <div className='flex-1 mt-5 w-full flex justify-center bg-gradient-radial items-center pt-16'>
//             <div className='text-5xl font-urbanist text-white'>My Profile Page Coming Soon...</div>
//         </div>
//     )
// }
export function MyProfile() {
    const { user } = useContext(AuthContext);
    if (user?.role === 'trainer') {
        return (
            <CreateTrainer />
        )
    } else if (user?.role === 'gym') {
        return (
            <CreateGymProfile />
        )
    } else if (user?.role === 'training-provider') {
        return (
            <CreateTrainingProvider />
        )
    } else {
        return (
            <div className='flex-1 mt-5 w-full flex justify-center bg-gradient-radial items-center pt-16'>
                <div className='text-5xl font-urbanist text-white'>My Profile Page Coming Soon...</div>
            </div>
        )
    }
}
